import React from 'react';
import styled from 'styled-components';
import { IconType } from 'react-icons';

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

interface IconProps {
  icon: IconType;
  size?: number | string;
  color?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ icon, size, color, className }) => {
  // Renderizamos o ícone como uma função
  const renderIcon = () => {
    const IconComponent = icon;
    return IconComponent ? IconComponent({ size, color }) : null;
  };

  return (
    <IconWrapper className={className}>
      {renderIcon()}
    </IconWrapper>
  );
};

export default Icon; 